export const alexImage =
  'https://firebasestorage.googleapis.com/v0/b/aryash-dubey.appspot.com/o/209289868_187870273180366_305638107167754847_n.jpg?alt=media&token=963cf3a6-3838-41de-908d-e16c8fb7d64c';
